import { render, staticRenderFns } from "./ModalMonitor.vue?vue&type=template&id=37dd0108"
import script from "./ModalMonitor.vue?vue&type=script&lang=js"
export * from "./ModalMonitor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports